var _circle, _circle2, _path, _circle3, _circle4, _path2, _circle5, _circle6, _path3, _path4, _circle7, _circle8, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadingVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 129,
    viewBox: "0 0 135 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.432,
    cy: 102.826,
    r: 17.7236,
    transform: "rotate(92.587 63.432 102.826)",
    fill: "#F8A87C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.3461,
    cy: 100.73,
    r: 17.7236,
    transform: "rotate(92.587 65.3461 100.73)",
    fill: "#E48955"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.151 116.71C63.6119 116.923 61.1453 115.657 61.0792 114.868C60.8605 112.255 63.454 115.036 65.9931 114.823C68.5323 114.611 70.7522 112.674 70.8183 113.464C71.0083 115.734 68.6902 116.497 66.151 116.71Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.9166,
    cy: 63.0928,
    r: 13.436,
    transform: "rotate(92.587 33.9166 63.0928)",
    fill: "#F8A87C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.3697,
    cy: 61.5038,
    r: 13.436,
    transform: "rotate(92.587 35.3697 61.5038)",
    fill: "#E48955"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9811 73.6178C34.0563 73.7789 32.1864 72.8198 32.1363 72.221C31.9705 70.2402 33.9365 72.3486 35.8614 72.1875C37.7863 72.0264 39.4692 70.5581 39.5193 71.1569C39.6634 72.8778 37.906 73.4567 35.9811 73.6178Z",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.1232,
    cy: 46.1768,
    r: 30.1184,
    transform: "rotate(92.587 89.1232 46.1768)",
    fill: "#FF7425"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5021,
    cy: 43.3271,
    r: 30.1184,
    transform: "rotate(92.587 92.5021 43.3271)",
    fill: "#DD621D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2817 69.9164C86.3727 69.6946 81.9321 67.4601 81.9817 66.363C82.1457 62.7338 86.4911 67.0741 91.4001 67.296C96.3091 67.5178 100.992 65.3092 100.942 66.4063C100.799 69.5592 96.1907 70.1382 91.2817 69.9164Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5619 64.3233C79.4136 65.3723 77.6323 65.2918 76.5833 64.1435C75.5343 62.9953 75.6148 61.214 76.7631 60.165C77.9114 59.116 77.6135 61.0959 78.6625 62.2441C79.7115 63.3924 81.7102 63.2743 80.5619 64.3233Z",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8925,
    cy: 74.8633,
    r: 11.2336,
    transform: "rotate(34.352 19.8925 74.8633)",
    fill: "#FF7425"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.6542,
    cy: 73.2317,
    r: 11.2336,
    transform: "rotate(34.352 19.6542 73.2317)",
    fill: "#DD621D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8438 78.8399C26.8096 80.3531 25.2291 81.3225 24.8909 81.0914C23.7722 80.3268 26.0018 79.801 27.0361 78.2879C28.0703 76.7747 28.2893 74.8562 28.6275 75.0873C29.5994 75.7516 28.878 77.3268 27.8438 78.8399Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9638 81.1413C24.071 81.7114 23.6957 82.2605 23.1256 82.3677C22.5555 82.4749 22.0064 82.0996 21.8992 81.5295C21.792 80.9593 22.3614 81.4426 22.9315 81.3354C23.5016 81.2282 23.8566 80.5712 23.9638 81.1413Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadingVector);
export default __webpack_public_path__ + "static/media/heading-vector.3aa6a6c83594542b4d238ba6dcbdd3be.svg";
export { ForwardRef as ReactComponent };